const Profile = () => {
    return <div>
        <b>This is Profile component</b>
    </div>
}

export default Profile